module.exports = __webpack_public_path__ + "media/images/markers/chubby_marker-00b610d339c67e801b81ed134871694a.svg";